import {
  INICIO_CANTINA,
  INICIO_CANTINA_SUCESSO,
  INICIO_CANTINA_FALHA,
  ON_SHOW_LOADER,
  INIT_URL,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_ERROR_MESSAGE,
  SETAR_COMBO_ESCOLA_CANTINA,
  BUSCAR_REGISTRO_RESTRICOES_SUCESSO,
  BUSCAR_REGISTRO_CANTINA_TURMA_SUCESSO,
  BUSCAR_REGISTRO_CANTINA_IDADE_SUCESSO,
  CANTINA_LISTA_ESCOLAS,
  CANTINA_LISTA_ESCOLAS_SUCESSO
} from "constants/ActionTypes";
import { preparaListaParaCombo } from 'luxFw/transformations/Common';

const INIT_STATE = {
  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  registrosCantinaTurma: {
    totalPresente: 0,
    totalAusente: 0,
    totalRestricoes: 0,
    cantinaPorTurma: []
  },
  registrosCantinaIdade: {
    totalPresente: 0,
    cantinaPorIdade: []
  },
  restricoes: {
    turma: "",
    totalRestricoes: 0,
    restricoes: [
      {
        nome: "string",
        imagem: "string",
        idade: 0,
        restricoes: [
          "string"
        ],
        qtdRestricoes: 0
      }
    ]
  },
  listaDeEscolas: [],
  idEscola: 0,
  combo: {
    idEscola: 0
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIO_CANTINA: {
      return {
        ...state,
        edicao: false,
        carregandoLista: true,
      }
    }
    case SETAR_COMBO_ESCOLA_CANTINA: {
      return {
        ...state,
        idEscola: action.payload,
      }
    }
    case BUSCAR_REGISTRO_CANTINA_TURMA_SUCESSO: {
      return {
        ...state,
        registrosCantinaTurma: action.payload,
        loader:false
      }
    }
    case BUSCAR_REGISTRO_RESTRICOES_SUCESSO: {
      return {
        ...state,
        restricoes: action.payload,
        loader:false
      }
    }
    case CANTINA_LISTA_ESCOLAS_SUCESSO: {
      const retorno = action.payload;
        return {
        ...state,
          listaDeEscolas:  preparaListaParaCombo(retorno, "id", "nome") || []
        };
    }
    case BUSCAR_REGISTRO_CANTINA_IDADE_SUCESSO: {
      return {
        ...state,
        registrosCantinaIdade: action.payload,
        loader:false
      }
    }
    case INICIO_CANTINA_SUCESSO: {
      return {
        ...state,
        loader: false
      }
    }

    case INICIO_CANTINA_FALHA: {
      return {
        ...state,
        trocaSenhaExpirada: true
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      }
    }
    default:
      return state;
  }
}